// tslint:disable
import axios from "axios"
import { CardModel, CardSortOrder } from "../models/card.model";
import { BaseService } from "./base.service";

class CardService extends BaseService {

    constructor(){
        super();
        console.log("created a instance of CardService");
    }

    async delete(id: number){
        let result = await  axios.delete(`${this.api}card/DeleteCard?id=${id}`);
        return result;
        // return this.execute('delete', `card/${id}`);
    }

    async getAll(getAllCommand:any){
        return axios.get(`${this.api}card/GetCardListWithImage?companyId=${getAllCommand}`).then(req => { return req.data; });
    }

    async getAllKeyValueOnPinBoard(pinBoardId:number){
        return axios.get(`${this.api}card/GetCardKeyValueListOnPinBoard?pinBoardId=${pinBoardId}`).then(req => { return req.data; });
    }

    async getAllKeyValue(){
        return axios.get(`${this.api}card/GetCardKeyValueList`).then(req => { return req.data; });
    }

    async getCount(){
        return axios.get(`${this.api}card/count`).then(req => { return req.data; });
    }

    async get<CardModel>(id: number){
        return axios.get<CardModel>(`${this.api}card/GetCard?id=${id}`).then(req => { return req.data; });
    }

    async getDetails(id: number){
        return axios.get(`${this.api}card/details/${id}`).then(req => { return req.data; });
    }

    async create(card: CardModel){
        let result = await axios.post(`${this.api}card/CreateCard`, card);
        return result;
    }

    async update(card: CardModel){
        // return axios.put(`${this.api}card/UpdateCard`, card).then(req => { return req.data; }).catch(error => { return error.response; });
        var result = await axios.put(`${this.api}card/UpdateCard`, card);
        return result;
    }

    async updateCardsSortOrder(pinBoardId:number, list: CardSortOrder[]){
        // return axios.put(`${this.api}card/UpdateCard`, card).then(req => { return req.data; }).catch(error => { return error.response; });
        var result = await axios.put(`${this.api}card/UpdateCardsSortOrder`, {cardList: list, pinBoardId: pinBoardId} );
        return result;
    }

    async moveCardUser(cardUserInfo: any){
        // return axios.put(`${this.api}card/UpdateCard`, card).then(req => { return req.data; }).catch(error => { return error.response; });
        var result = await axios.put(`${this.api}card/MoveUserCard`, cardUserInfo);
        return result;
    }

    async setAvailability(setCardAvailabilityCommand: any) {
        let result = await axios.put(`${this.api}card/UpdateCardAvailability/`, setCardAvailabilityCommand).then(req => { return req.data; });
        return result;
    }

    async getAllByPinBoardId(pinboardId: number){
        return axios.get(`${this.api}card/GetCardListOnPinBoard?pinBoardId=${pinboardId}`).then(req => { return req.data; });
    }

    async createImage(formData:FormData, cardId:number){
        return axios.post(`${this.api}card/CreateImage/?cardId=${cardId}`, 
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }

    async updateImage(formData:FormData, cardId:number){
        return axios.put(`${this.api}card/UpdateImage/?cardId=${cardId}`, 
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }
}

export const cardService = new CardService();

